var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 172,
    viewBox: "0 0 177 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3891 32.0327H130.614C127.187 20.6916 121.767 9.82207 114.326 0H0.101562C7.53542 9.82207 12.9623 20.6916 16.3891 32.0327Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.807 62.9161V96.0725H142.061C148.123 78.9533 149.502 60.5438 146.191 42.835H19.0029C23.3308 66.0098 19.6378 90.3915 7.92383 111.499L74.4121 111.118L117.814 62.9161H117.807Z",
    fill: "#196BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4063 153.098V123.264L0.287109 123.479L32.6029 172H58.9934H136.561H136.663V171.827L174.836 108.011H101.808L58.4063 153.098Z",
    fill: "#196BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.809 107.996H176.103V105.846L174.809 107.996Z",
    fill: "#196BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.101562 123.481L0.25248 123.474L0.101562 123.26V123.481Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinLogo);
export default __webpack_public_path__ + "static/media/finLogo.c685d4e6bb0cd81542af6b33c4adf10e.svg";
export { ForwardRef as ReactComponent };